import {
  PageContainer,
  PageTitle,
} from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { MarketingProduct } from "@/product-marketing/types";
import { PRODUCT_MARKETING } from "./content";
import { ProductBenefits } from "./product-benefits";
import { ProductContact } from "./product-contact";
import { ProductExample } from "./product-example";

export const ProductMarketingPage = ({
  product,
}: {
  product: MarketingProduct;
}) => {
  const content = PRODUCT_MARKETING[product];
  return (
    <section
      aria-labelledby="product-marketing-title"
      className="min-h-full text-ink"
    >
      <PageContainer className="max-w-6xl pt-12 md:pt-20">
        <div className="grid w-full items-start gap-10 lg:grid-cols-2 lg:gap-14">
          <Stack align="start" gap={8}>
            <Stack align="start" gap={5}>
              <PageTitle id="product-marketing-title">
                {content.title}
              </PageTitle>
              <Text tone="muted" className="max-w-prose text-pretty">
                {content.summary}
              </Text>
              <ProductContact product={product} />
            </Stack>
            <ProductBenefits product={product} />
          </Stack>
          <ProductExample product={product} />
        </div>
      </PageContainer>
    </section>
  );
};
